/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Button/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CameraOnIcon from 'DesignSystem/Svgs/CameraOnIcon/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Button({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Content/Button",
  onClick
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtTypographyFontsizeXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Button.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-2mwm5H': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 block={true}
 marginTop={dtSpaceXs}
 justifyContent="center"
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<CameraOnIcon
{...childProps}
  viewPath={`${viewPath}/CameraOnIcon`}
 marginRight={dtSpaceXxs}
 stroke="white"
 fill="white"
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 fontSize={dtTypographyFontsizeXs}
 text="Take a picture"
/>
</React.Fragment>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}